import React, { useEffect, useState } from 'react';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import PropTypes from 'prop-types';
import AdminUserDetails from './adminUserDetails';
import AdminOrdersTable from '../orders/adminOrdersTable';
import { useSubscriptions } from './apiHooks';
import AdminSubscriptionsTable from '../subscriptions/adminSubscriptionsTable';

const AdminUsersUser = ({ setLoading, setError, match }) => {
  const [user, setUser] = useState(null);
  const [orderBatches, setOrderBatches] = useState([]);

  const { subscriptions } = useSubscriptions({
    max: 100,
    userId: match.params.userId,
    admin: true,
  });

  useEffect(() => {
    getUser().then((user) => getOrderBatches(user.id));
  }, []);

  function getUser() {
    setLoading(true);
    return apiCalls
      .getUsersAdmin({
        userId: match.params.userId,
      })
      .then((result) => {
        setUser(result.data.users[0]);
        return result.data.users[0];
      })
      .catch((errors) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  function getOrderBatches(userId) {
    return apiCalls
      .getOrderBatches({
        userId,
      })
      .then((result) => {
        setOrderBatches(result.data.orderBatches);
        setLoading(false);
      })
      .catch((errors) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  return (
    <div>
      {user ? (
        <div className="row">
          <div className="col-12 col-md-6">
            <AdminUserDetails user={user} />
          </div>
        </div>
      ) : (
        ''
      )}

      <h3>Subscriptions</h3>
      <AdminSubscriptionsTable subscriptions={subscriptions} />

      <h3>Orders</h3>
      <AdminOrdersTable orderBatches={orderBatches} getOrderBatches={getOrderBatches} setSortMethod={() => {}} />
    </div>
  );
};

AdminUsersUser.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminUsersUser.defaultProps = {};

export default AdminUsersUser;
